export const THEME_ASSET_PUBLIC_BASE_PATH = '/assets/images'

export const THEME_ASSET_EXTENSIONS = ['.png', '.svg', '.jpg', '.jpeg', '.webp'] as const

export type ThemeAssetExtension = (typeof THEME_ASSET_EXTENSIONS)[number]

/**
 * Canonical assets that intentionally have no `.dark` sibling.
 * Exact paths relative to `public/assets/images/` — no wildcards.
 * During the staged rollout, every existing asset starts here until reviewed.
 */
export const THEME_ASSET_EXEMPTIONS: readonly string[] = [
  'Alvie-logo_extended-full.svg',
  'add_icon.svg',
  'adobe_analytics.svg',
  'adtraction.svg',
  'alien_w_flag.png',
  'alvie-with-padding.svg',
  'alvie_icon_duotone.svg',
  'alvie_learning_center_icon.svg',
  'amazon_ads.svg',
  'asset1.png',
  'asset2.png',
  'asset3.png',
  'asset4.png',
  'asset5.png',
  'asset6.png',
  'banner_splash.png',
  'box_2.svg',
  'calculator_icon.svg',
  'check.png',
  'cj_affiliate.svg',
  'cm_360_logo.svg',
  'column_chart.svg',
  'comparative_analysis.png',
  'confluence.svg',
  'criteo.svg',
  'custom_groupings.svg',
  'custom_report.png',
  'dashboard_w_new_tag.png',
  'data_source.svg',
  'data_sources.svg',
  'divide_icon.svg',
  'dv360.svg',
  'email_symbol.png',
  'audience_network_interstitial_brand_icon.png',
  'facebook_avatar_placeholder.png',
  'facebook_reaction_heart.png',
  'facebook_reaction_like.png',
  'file_upload_icon.svg',
  'fivetran-logo.svg',
  'fivetran.svg',
  'funnel.png',
  'gcp.svg',
  'globe.svg',
  'google.png',
  'google.svg',
  'google_ads.svg',
  'google_analytics_4.svg',
  'google_analytics_ua.svg',
  'google_bigquery.svg',
  'google_doc.png',
  'google_doc_rounded.png',
  'google_drive_icon.png',
  'google_search_console.svg',
  'google_sheets.svg',
  'google_slides_icon.svg',
  'google_slides_rounded.png',
  'google_tag_manager.svg',
  'hubspot.svg',
  'information.svg',
  'keyboard.png',
  'klaviyo.svg',
  'lamp.png',
  'lampInContainer.png',
  'lego_blocks.png',
  'lightning_icon.svg',
  'linkedin.svg',
  'looker_studio.png',
  'magicWandInContainer.png',
  'mail_opened.png',
  'mail_opened_checkmark.png',
  'man_at_campfire.png',
  'man_w_phone.png',
  'merchant_center.svg',
  'meta_ads.png',
  'microsoft.png',
  'microsoft_ads.svg',
  'microsoft_excel_rounded.png',
  'microsoft_powerpoint_rounded.png',
  'microsoft_word_rounded.png',
  'mimir-icon-transparent.png',
  'mimir-icon.png',
  'multiply_icon.svg',
  'no_carousel.svg',
  'no_image.svg',
  'no_recommendations.svg',
  'no_video.svg',
  'openai.svg',
  'opened_book.png',
  'padlock.png',
  'padlock_new.png',
  'partnerize.svg',
  'pause.png',
  'piechart_3d.png',
  'pinterest.svg',
  'plane.png',
  'plant.png',
  'promoBannerPinterest.png',
  'quantcast.svg',
  'recommendations_setup_error.svg',
  'reddit_ads.svg',
  'reportingSolution.svg',
  'rtb_house.svg',
  'rubik.svg',
  'settings.svg',
  'settingsInContainer.png',
  'shopify.svg',
  'shopping_bag_icon.svg',
  'slack.png',
  'slack.svg',
  'snapchat.svg',
  'space-man.svg',
  'spotify_ads.svg',
  'stackadapt.svg',
  'star_wand.svg',
  'stripe.svg',
  'subtract_icon.svg',
  'successInContainer.png',
  'supermetrics.svg',
  'supermetrics_logo.svg',
  'teamwork_spaces_icon.png',
  'tiktok.svg',
  'tools.svg',
  'toolsInContainer.png',
  'top_performing.png',
  'tradedoubler.svg',
  'unassigned_icon.svg',
  'unknown-icon.svg',
  'video_deep_dive.png',
  'website.png',
  'winning_combinations.png',
  'woocommerce.svg',
  'x.svg',
  'yellow_cone.png'
]
